'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Cookies = require('Cookies');

var _Cookies2 = _interopRequireDefault(_Cookies);

var _AppLoginDao = require('./dao/AppLoginDao');

var _AppLoginDao2 = _interopRequireDefault(_AppLoginDao);

var _BaseCookieLogin2 = require('../BaseCookieLogin');

var _BaseCookieLogin3 = _interopRequireDefault(_BaseCookieLogin2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VISIT_PATH = '/login-api/v1/login/visit';
var COOKIE_VERIFIED_KEY = 'cookieverified';

var BaseAppCookieLogin = function (_BaseCookieLogin) {
  _inherits(BaseAppCookieLogin, _BaseCookieLogin);

  function BaseAppCookieLogin(lbs, loginRequest, passThroughFallback) {
    _classCallCheck(this, BaseAppCookieLogin);

    var _this = _possibleConstructorReturn(this, (BaseAppCookieLogin.__proto__ || Object.getPrototypeOf(BaseAppCookieLogin)).call(this, lbs, loginRequest || _AppLoginDao2.default.login, _AppLoginDao2.default.prep, VISIT_PATH));

    _this.passThroughFallback = passThroughFallback || false;
    return _this;
  }

  _createClass(BaseAppCookieLogin, [{
    key: 'loginRequests',
    value: function loginRequests(credentials) {
      this.credentials = credentials;
      if (credentials.passThrough) {
        return this.passThroughLogin(credentials);
      }
      return this.loginRequestsInternal(credentials);
    }
  }, {
    key: 'collectLoginResponses',
    value: function collectLoginResponses(loginResponses) {
      var _get2;

      (_get2 = _get(BaseAppCookieLogin.prototype.__proto__ || Object.getPrototypeOf(BaseAppCookieLogin.prototype), 'collectLoginResponses', this)).call.apply(_get2, [this].concat(_toConsumableArray(loginResponses)));
      var twoFactorRequired = loginResponses.length > 0 && loginResponses[0].status === 'TWO_FACTOR_REQUIRED';

      if (!this.credentials.passThrough && !twoFactorRequired) {
        return this.verifyCookie({ loginResponses: loginResponses, firstAttempt: true });
      }
      return loginResponses;
    }
  }, {
    key: 'verifyCookie',
    value: function verifyCookie(_ref) {
      var _this2 = this;

      var loginResponses = _ref.loginResponses,
          firstAttempt = _ref.firstAttempt;

      var verifyParameters = { firstAttempt: firstAttempt };
      if (this.credentials) {
        verifyParameters.email = this.credentials.email;
      }
      return _AppLoginDao2.default.verify(verifyParameters).then(function () {
        return true;
      }).catch(function (error) {
        console.error(error);
        return false;
      }).then(function (cookieVerified) {
        _Cookies2.default.set(COOKIE_VERIFIED_KEY, cookieVerified ? '1' : '0', { path: '/', secure: true, expires: 365, domain: _this2.currentDomain });
        if (_this2.passThroughFallback && !cookieVerified) {
          return _this2.passThroughLogin(_this2.credentials);
        } else {
          return loginResponses;
        }
      });
    }
  }, {
    key: 'passThroughLogin',
    value: function passThroughLogin(credentials) {
      var _this3 = this;

      var passThroughCredentials = _extends({}, credentials, { passThrough: true });
      return this.loginRequest(passThroughCredentials, 'app').then(function (response) {
        _Cookies2.default.set('csrf.app', response.csrfToken, { path: '/', secure: true, expires: 365, domain: _this3.currentDomain });
        return [response];
      });
    }
  }, {
    key: 'redirectOnLoginSuccess',
    value: function redirectOnLoginSuccess(_ref2) {
      var _ref3 = _slicedToArray(_ref2, 1),
          redirectUrl = _ref3[0].redirectUrl;

      window.location = redirectUrl;
    }
  }]);

  return BaseAppCookieLogin;
}(_BaseCookieLogin3.default);

exports.default = BaseAppCookieLogin;
module.exports = exports['default'];